import fetcher from '../utils/api';

const superOrganizationService = {
  getInfo: async () => fetcher(`super_organizations/`, 'GET', true),
  getTeamsInfo: async (id) => fetcher(`super_organization/${id}/info/`, 'GET', true),
  updateAgreedToMsa: async (id, checked) => fetcher(`super_organization/${id}/msa/`, 'PATCH', true, { agreed_to_msa: checked }),
  updateOrgProvisioningStatus: async (id, body) => fetcher(`organization_external_links/${id}/`, 'PATCH', true, body),
  listExternalLinks: async ({ searchQuery, skip, getFirst }) => {
    const additionalParams = [];
    // name query

    if (searchQuery && searchQuery.trim().length > 1) {
      additionalParams.push(`query=${encodeURIComponent(searchQuery.trim())}`);
    }

    if (skip !== undefined && skip !== null) {
      additionalParams.push(`skip=${encodeURIComponent(skip)}`);
    }

    if (getFirst !== undefined && getFirst !== null) {
      additionalParams.push(`get_first=${encodeURIComponent(getFirst)}`);
    }
    return fetcher('organization_external_links/' + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', true);
  },
  listSuperOrganizationUsers: async (id, roleToExcludeId) =>
    fetcher(`super_organization/${id}/users/${roleToExcludeId ? `?not_in_role=${roleToExcludeId}` : ''}`, 'GET', true),
  updateDefaultRole: async (id, roleId) =>
    fetcher(`super_organizations/${id}/`, 'PATCH', true, {
      default_role_id: roleId
    }),
  getUsageSummary: async () => fetcher(`super_organization/usage_summary/`, 'GET', true),
  getPortalLink: async (id, intent) =>
    fetcher(`super_organization/${id}/get_workos_portal_link/`, 'POST', true, { intent: intent ?? 'sso' }),
  createWorkOSOrganization: async (id) => fetcher(`super_organization/${id}/create_workos_organization/`, 'POST', true, {}),
  notifyAdminsFailedPayment: async (id) => fetcher(`super_organization/${id}/failed_payment/`, 'POST', true)
};

export default superOrganizationService;
